<template>
  <v-row justify="center" align="center" class="skewed-bg">
    <v-col cols="12" sm="11" md="10" lg="10" style="z-index:1">
      <v-row style="z-index:1">
        <v-spacer></v-spacer>

        <v-col cols="12" sm="3" md="3" class="py-0">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formatDatePicker(date)"
                filled
                background-color="white"
                dense
                single-line
                label="วันที่"
                prepend-icon="event"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" locale="th" @input="menu = false" :max="today"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-card>
        <v-card-title>
          <h1>แบบประเมินความพึงพอใจ</h1>
        </v-card-title>
        <v-row>
          <v-col>
            <v-row justify="center" align="center">
              <v-col cols="12" sm="6" md="6" align="center">
                <div id="card">
                  <div id="chart">
                    <apexchart
                      type="radialBar"
                      height="350"
                      :options="chartOptions"
                      :series="series"
                    ></apexchart>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-container>
                  <v-card class="px-5" outlined>
                    <v-card-title>
                      <h2>ระดับคะแนนความพึงพอใจ</h2>
                    </v-card-title>
                    <v-list>
                      <v-list-item v-for="item in items" :key="item.text" class="py-0">
                        <v-list-item-content>
                          <v-col class="pa-0">
                            <v-chip
                              small
                              text-color="black"
                              :color="item.bgcolor"
                              :style="{ 'padding-right': item.width }"
                            >
                              <v-avatar small left>
                                <v-icon small :color="item.color">mdi-circle</v-icon>
                              </v-avatar>
                              <span class="text_body_7">
                                {{
                                item.value + " คะแนน "
                                }}
                              </span>
                            </v-chip>
                          </v-col>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-list-item-action-text class="text_body_7">{{ item.text }}</v-list-item-action-text>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-container>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-avatar>
                  <img src="@/assets/icon/User.svg" />
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  class="text_body_6"
                >{{ "จำนวนผู้ทำแบบประเมิน : " + summary.allCount + " คน" }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-avatar>
                <v-avatar>
                  <img src="@/assets/icon/Star.svg" />
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text_body_6">
                  {{
                  summary.avgPoint
                  ? "คะแนน : " + summary.avgPoint + " คะแนน"
                  : "คะแนน : 0 คะแนน"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-title>
          <h2>ข้อเสนอแนะ</h2>
        </v-card-title>
        <v-card-subtitle class="text_body_7 ml-5" v-if="comment.length == 0">- ไม่มีข้อเสนอแนะ</v-card-subtitle>

        <v-container>
          <v-card
            v-for="(item, index) in comment"
            :key="index"
            outlined
            class="mb-5"
            v-show="item.comment"
          >
            <v-list two-line>
              <v-list-item>
                <!-- <v-list-item-avatar>
                  <img src="@/assets/icon/User.svg" />
                </v-list-item-avatar>-->

                <v-list-item-content>
                  <v-list-item-title class="text_title_6">
                    {{
                    "ข้อเสนอแนะที่ " + parseInt(index + 1) + " : "
                    }}
                  </v-list-item-title>
                  <!-- <v-list-item-subtitle class="text_body_6"> -->
                  <span class="text_body_6 grey--text">{{ item.comment }}</span>
                  <!-- </v-list-item-subtitle> -->
                </v-list-item-content>
              </v-list-item>
              <v-spacer></v-spacer>
              <v-col class="py-0" align="right">
                <span class="text_title_7">
                  {{
                  formatTime(item.createdAt) +
                  " น. " +
                  thaiLongFormatDate(item.createdAt)
                  }}
                </span>
              </v-col>
            </v-list>
          </v-card>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      bg_color: "",
      date: new Date().toISOString().substr(0, 10),
      today: new Date().toISOString().substr(0, 10),
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      menu: false,
      series: [0],
      chartOptions: {
        chart: {
          height: 400,
          type: "radialBar",
          // toolbar: {
          //   show: true,
          // },
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
              margin: 0,
              size: "50%",
              background: "#fff",
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: "front",
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24,
              },
            },
            track: {
              background: "#fff",
              strokeWidth: "67%",
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.35,
              },
            },

            dataLabels: {
              show: true,
              name: {
                offsetY: -10,
                show: true,
                color: "#888",
                fontSize: "17px",
              },
              value: {
                formatter: function (val) {
                  return parseInt(val) / 20;
                },
                color: "#111",
                fontSize: "36px",
                show: true,
              },
            },
          },
        },
        // fill: {
        //   colors: ["#dbecf8"],
        //   // type: "gradient",
        //   // gradient: {
        //   //   shade: "dark",
        //   //   type: "horizontal",
        //   //   shadeIntensity: 0.5,
        //   //   gradientToColors: ["", this.bg_color],
        //   //   inverseColors: true,
        //   //   opacityFrom: 1,
        //   //   opacityTo: 1,
        //   //   stops: [0, 100],
        //   // },
        // },
        stroke: {
          lineCap: "round",
        },
        labels: ["คะแนน"],
      },

      items: [
        {
          text: "มากที่สุด",
          value: 5,
          percents: 100,
          bgcolor: "#d6e9bf",
          color: "#5aa700",
          width: "50%",
        },
        {
          text: "มาก",
          value: 4,
          percents: 80,
          bgcolor: "#98d6ea",
          color: "#2b82bd",
          width: "40%",
        },
        {
          text: "ปานกลาง",
          value: 3,
          percents: 60,
          bgcolor: "#befcff",
          color: "#7db8ff",
          width: "30%",
        },
        {
          text: "น้อย",
          value: 2,
          percents: 40,
          bgcolor: "#faebca",
          color: "#edae2b",
          width: "20%",
        },
        {
          text: "น้อยที่สุด",
          value: 1,
          percents: 20,
          bgcolor: "#e89494",
          color: "#d12828",
          width: "10%",
        },
      ],
      summary: [],
      comment: [],
    };
  },
  created() {
    const module_name = "permission_backOffice";
    const func_name = "satisfaction";
    const redirect = { name: "Dashboard", params: { mode: "all" } };
    if (this.$session.get(module_name)) {
      if (this.$session.get(module_name).includes(func_name)) {
        this.initialMethod();
      } else {
        this.$router.push(redirect);
      }
    } else {
      this.$router.push(redirect);
    }
  },
  watch: {
    date(val) {
      if (val) {
        this.getSummary(val);
        this.getComment(val);
      }
    },
  },
  methods: {
    initialMethod() {
      this.getSummary(this.date);
      this.getComment(this.date);
    },
    getSummary(date) {
      var qstr = "?date=" + date;
      this.axios
        .get(
          process.env.VUE_APP_API + "api/v1/feedback/summary" + qstr,
          this.header_token
        )
        .then((res) => {
          // console.log(res.data);
          this.summary = res.data;

          var score = 0;

          score = this.summary.avgPoint;
          // this.bg_color = this.getBGColor(score);

          if (score == 0) {
            this.series = [0];
            this.chartOptions = {
              chart: {
                height: 400,
                type: "radialBar",
                // toolbar: {
                //   show: true,
                // },
              },
              plotOptions: {
                radialBar: {
                  startAngle: -135,
                  endAngle: 225,
                  hollow: {
                    margin: 0,
                    size: "50%",
                    background: "#fff",
                    image: undefined,
                    imageOffsetX: 0,
                    imageOffsetY: 0,
                    position: "front",
                    dropShadow: {
                      enabled: true,
                      top: 3,
                      left: 0,
                      blur: 4,
                      opacity: 0.24,
                    },
                  },
                  track: {
                    background: "#fff",
                    strokeWidth: "67%",
                    margin: 0, // margin is in pixels
                    dropShadow: {
                      enabled: true,
                      top: -3,
                      left: 0,
                      blur: 4,
                      opacity: 0.35,
                    },
                  },

                  dataLabels: {
                    show: true,
                    name: {
                      offsetY: -10,
                      show: true,
                      color: "#888",
                      fontSize: "17px",
                    },
                    value: {
                      formatter: function (val) {
                        return parseInt(val) / 20;
                      },
                      color: "#111",
                      fontSize: "36px",
                      show: true,
                    },
                  },
                },
              },
              fill: {
                // colors: ["#dbecf8"],
                type: "gradient",
                gradient: {
                  shade: "dark",
                  type: "horizontal",
                  shadeIntensity: 0.5,
                  gradientToColors: ["#dbecf8"],
                  inverseColors: true,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100],
                },
              },
              stroke: {
                lineCap: "round",
              },
              labels: ["คะแนน"],
            };

            // this.chartOptions = {
            //   tooltip: {
            //     enabled: false,
            //   },
            //   chart: {
            //     width: 380,
            //     type: "donut",
            //   },
            //   dataLabels: {
            //     enabled: false,
            //   },
            //   fill: {
            //     type: "gradient",
            //   },
            //   colors: ["#dbecf8", "#dbecf8"],
            //   legend: {
            //     show: false,
            //     onItemClick: {
            //       toggleDataSeries: false,
            //     },
            //     onItemHover: {
            //       highlightDataSeries: false,
            //     },
            //   },
            //   responsive: [
            //     {
            //       breakpoint: 480,
            //       options: {
            //         chart: {
            //           width: 200,
            //         },
            //         legend: {
            //           position: "bottom",
            //         },
            //       },
            //     },
            //   ],
            // };
          } else {
            this.items.forEach((element) => {
              if (score == element.value) {
                // console.log(element.color);

                this.series = [element.percents];
                this.chartOptions = {
                  chart: {
                    height: 400,
                    type: "radialBar",
                    // toolbar: {
                    //   show: true,
                    // },
                  },
                  plotOptions: {
                    radialBar: {
                      startAngle: -135,
                      endAngle: 225,
                      hollow: {
                        margin: 0,
                        size: "50%",
                        background: "#fff",
                        image: undefined,
                        imageOffsetX: 0,
                        imageOffsetY: 0,
                        position: "front",
                        dropShadow: {
                          enabled: true,
                          top: 3,
                          left: 0,
                          blur: 4,
                          opacity: 0.24,
                        },
                      },
                      track: {
                        background: "#fff",
                        strokeWidth: "67%",
                        margin: 0, // margin is in pixels
                        dropShadow: {
                          enabled: true,
                          top: -3,
                          left: 0,
                          blur: 4,
                          opacity: 0.35,
                        },
                      },

                      dataLabels: {
                        show: true,
                        name: {
                          offsetY: -10,
                          show: true,
                          color: "#888",
                          fontSize: "17px",
                        },
                        value: {
                          formatter: function (val) {
                            return parseInt(val) / 20;
                          },
                          color: "#111",
                          fontSize: "36px",
                          show: true,
                        },
                      },
                    },
                  },
                  fill: {
                    colors: [element.color],
                    // type: "gradient",
                    // gradient: {
                    //   shade: "dark",
                    //   type: "horizontal",
                    //   shadeIntensity: 0.5,
                    //   gradientToColors: [element.color, this.bg_color],
                    //   inverseColors: true,
                    //   opacityFrom: 1,
                    //   opacityTo: 1,
                    //   stops: [0, 100],
                    // },
                  },
                  stroke: {
                    lineCap: "round",
                  },
                  labels: ["คะแนน"],
                };
                //   this.chartOptions = {
                //     tooltip: {
                //       enabled: false,
                //     },
                //     chart: {
                //       width: 380,
                //       type: "donut",
                //     },
                //     dataLabels: {
                //       enabled: false,
                //     },
                //     fill: {
                //       type: "gradient",
                //     },
                //     colors: [element.color, "#dbecf8"],
                //     legend: {
                //       show: false,
                //     },
                //     responsive: [
                //       {
                //         breakpoint: 480,
                //         options: {
                //           chart: {
                //             width: 200,
                //           },
                //           legend: {
                //             position: "bottom",
                //           },
                //         },
                //       },
                //     ],
                //   };
              }
            });
          }
        });
    },
    getBGColor(score) {
      var bg = "";
      if (score > 0) {
        this.items.forEach((element) => {
          if (parseInt(score) == parseInt(element.value)) {
            bg = element.bgcolor;
            this.bg_color = bg;
          }
        });
      }

      return bg;
    },
    getComment(date) {
      var qstr = "?date=" + date;
      this.axios
        .get(
          process.env.VUE_APP_API + "api/v1/feedback" + qstr,
          this.header_token
        )
        .then((res) => {
          var data = res.data;
          var comments = [];
          data.forEach((element) => {
            if (element.comment) {
              comments.push(element);
            }
          });
          // console.log(res.data);
          this.comment = comments;
        });
    },
    thaiShortFormatDate(datetime) {
      var date = datetime.split(" ")[0];
      if (!datetime) {
        return "";
      }
      var [year, month, day] = date.split("-");
      year = (parseInt(year) + 543).subString(2);
      switch (month) {
        case "01":
          month = "ม.ค.";
          break;
        case "02":
          month = "ก.พ.";
          break;
        case "03":
          month = "มี.ค.";
          break;
        case "04":
          month = "เม.ย.";
          break;
        case "05":
          month = "พ.ค.";
          break;
        case "06":
          month = "มิ.ย.";
          break;
        case "07":
          month = "ก.ค.";
          break;
        case "08":
          month = "ส.ค.";
          break;
        case "09":
          month = "ก.ย.";
          break;
        case "10":
          month = "ต.ค.";
          break;
        case "11":
          month = "พ.ย.";
          break;
        case "12":
          month = "ธ.ค.";
          break;

        default:
          break;
      }
      return day + " " + month + " " + year;
    },
    thaiLongFormatDate(datetime) {
      var date = datetime.split(" ")[0];
      if (!datetime) {
        return "";
      }
      var [year, month, day] = date.split("-");
      year = parseInt(year) + 543;
      switch (month) {
        case "01":
          month = "มกราคม";
          break;
        case "02":
          month = "กุมภาพันธ์";
          break;
        case "03":
          month = "มีนาคม";
          break;
        case "04":
          month = "เมษายน";
          break;
        case "05":
          month = "พฤษภาคม";
          break;
        case "06":
          month = "มิถุนายน";
          break;
        case "07":
          month = "กรกฎาคม";
          break;
        case "08":
          month = "สิงหาคม";
          break;
        case "09":
          month = "กันยายน";
          break;
        case "10":
          month = "ตุลาคม";
          break;
        case "11":
          month = "พฤศจิกายน";
          break;
        case "12":
          month = "ธันวาคม";
          break;

        default:
          break;
      }
      return day + " " + month + " " + year;
    },
    formatTime(datetime) {
      var time = datetime.split(" ")[1];
      var [hh, mm, ss] = time.split(":");
      return hh + ":" + mm;
    },
    formatDatePicker(date) {
      if (!date) {
        return null;
      }
      var [year, month, day] = date.split("-");
      return `${day}/${month}/${parseInt(year) + 543}`;
    },
  },
};
</script>
<style>
.skewed-bg {
  background: #e9f1fe;
  color: #fff;
  padding: 2em;
  position: relative;
  min-height: 300px;
  overflow: hidden;
  z-index: 0;
}
.skewed-bg::after {
  content: "";
  position: absolute;
  top: 200px;
  left: 0;
  right: 0;
  height: 100%;
  background: #fff;
  transform: skew(0deg, 0deg);
  z-index: 0;
}
.Radius-999px {
  width: 217px;
  height: 25px;
  border-radius: 999px;
  background-color: #d6e9bf;
}
</style>
